module.exports = __webpack_public_path__ + "static/media/calendar.44da4b96.svg";